import { ExternalLink } from './ExternalLink';
import { InternalLink } from './InternalLink';

export const Link = {
  Internal: InternalLink,
  External: ExternalLink,
};
